var EqModelLoader = /** @class */ (function () {
    function EqModelLoader(context) {
        this.context = context;
        this.modelPromise = null;
    }
    EqModelLoader.prototype.init = function (options) {
    };
    EqModelLoader.prototype.getContext = function () {
        return this.context;
    };
    EqModelLoader.prototype.createModelLoadingPromise = function () {
        var _this = this;
        this.modelPromise = new Promise(function (resolve, reject) {
            _this.modelLoadingResolveFunc = resolve;
            _this.modelLoadingRejectFunc = reject;
        });
    };
    /**
     * Returns the `Promise` of the model loading process
     */
    EqModelLoader.prototype.getModelPromise = function () {
        return this.modelPromise
            || Promise.reject(new Error("Model has been never loaded."));
    };
    EqModelLoader.prototype.startModelLoading = function (options) {
        this.createModelLoadingPromise();
        this.sendLoadModelRequest(options);
        return this.modelPromise;
    };
    return EqModelLoader;
}());
export { EqModelLoader };
//# sourceMappingURL=model_loader.js.map